import { AttendanceManagementTranslations } from "./attendance-management-pt-br";

export const ATTENDANCE_MANAGEMENT_ES_ES: AttendanceManagementTranslations = {
	attendanceManagement: "Gestión de Atención",
	environmentsAndTables: "Ambientes y mesas",
	createAndManageEnvironments: "Cree y gestione ambientes y mesas de su establecimiento.",
	searchByTable: "Buscar por mesa",
	statusConfiguration: "Configuración de estado",
	filter: "Filtrar",
	tablesInService: "Mesas en servicio",
	tablesNeedingAttention: "Mesas que necesitan atención",
	availableTables: "Mesas disponibles",
	seeMore: "Ver más",
	seeAll: "Ver todos",
	selectAll: "Seleccionar todos",
	loading: "Cargando...",
	paid: "Pagado",
	statusLabel: {
		Available: "Disponible",
		InService: "En servicio",
		Paid: "Pagado",
		InPayment: "En pago",
		Blocked: "Bloqueado",
	},
	statusDescription: {
		available: "Mesas disponibles para ser abiertas",
		inService1: "Mesas con servicio iniciado.",
		inService2: "Mesas sin interacción desde:",
		inPayment: "Mesas que ya han iniciado el pago.",
		blocked: "Mesas bloqueadas para reserva o inactividad.",
	},
	minutes: "minutos",
	emptyState: {
		title: "No se encontraron mesas",
		subtitle: "No hay mesas disponibles con los filtros seleccionados.",
	},
	form: {
		minutes: {
			required: "El campo minutos es obligatorio",
			placeholder: "Ingrese un valor entre 1 y 120",
		},
		submit: "Guardar cambios",
		successMessage: "Configuraciones guardadas con éxito",
	},
	updateTimeLabel: "Hora de actualización",
	updateTimeValue: "Actualizado en {{date}} a las {{time}}",
	attendanceManagementAlert: {
		title: "Aún no hay evento abierto",
		message:
			"La operación se iniciará después de la apertura del evento y podrás seguir los estados de las mesas.",
		openEvent: "Abrir evento",
	},
};
